export const LOCALES = {
    ENGLISH: 'en-US',
    RUSSIAN: 'ru-RU',
}